





var $       = require( 'jquery' );
var dt      = require( 'datatables' );

$(document).ready( function () {
    // Saved Search table
    $('#saved-search').DataTable({
        searching:false,
        paging:false,
        info:false,
        order : [[0,"desc"]],
        columnDefs: [
            {
                targets: [ 0 ],
                orderData: [0]
            },
            {
                targets: [ 1 ],
                orderData: [ 1 ]
            }
            ,
            {
                targets: [ 2 ],
                orderData: [ 2 ]
            }
            ,
            {
                targets: [ 6 ],
                orderData: [ 6 ]
            }
            ,
            {
                orderable: false,
                targets: [3,4,5,7,8,9,10,11,12,13]
            }
        ]
    });


    // Recent Search table
    $('#recent-search').DataTable({
        searching:false,
        paging:false,
        info:false,
        order : [[0,"desc"]],
        columnDefs: [
            {
                targets: [ 0 ],
                orderData: [0]
            },
            {
                targets: [ 1 ],
                orderData: [ 1 ]
            }
            ,
            {
                targets: [ 2 ],
                orderData: [ 2 ]
            }
            ,
            {
                targets: [ 6 ],
                orderData: [ 6 ]
            }
            ,
            {
                orderable: false,
                targets: [3,4,5,7,8,9,10,11,12,13]
            }
        ]
    });

    // Recent Search table
    $('#garage-list').DataTable({
        searching:false,
        autoWidth: false,
        paging:true,
        order : [[7,"desc"]],
        pageLength : 15,
        info:true,
        lengthChange:false,
        columns: [
            {
                "width": "5%"
            },
            {
                "width": "10%"
            },
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
        ],
        columnDefs: [
            {
                orderable: false,
                targets: [0]
            }
        ],
        language: {
            paginate: {
                previous: "<",
                next: ">",
            },
            info: "<strong>Showing</strong> _START_-_END_ of _TOTAL_ results",
        },
        dom : '<"top"i>rt<"bottom"p><"clear">'
    });

} );


// WEBPACK FOOTER //
// ./resources/js/datatables.js